export default {
    loginTitle: 'User Login',
    enterInformation: 'Enter your account information please',
    logout: 'Logout',
    welcomeLogin: 'Welcome back, please login to your account.',
    username: 'Username',
    password: 'Password',
    confirmation: 'Confirmation',
    forgetPassword: 'Forget password?',
    loginButton: 'Login',
    rememberMe: 'REMEMBER ME',
    login: 'Login',
    newUser: 'New on our platform?',
    createAnAccount: 'Create an account',
    profile: 'Profile',
    contact: 'Contact',
    role: 'Role',
    createdAt: 'Created At',
    changePassword: 'Change Password',
    newPassword: 'New Password',
    oldPassword: 'Old Password',
    backToProfile:'Back To Profile'

}